import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { PropertyEditor } from '../property-editor';
import { MultipleValues, PropertyInput } from './input-base';

export class CheckboxInput extends PropertyInput {
    private readonly checkboxSize: number = 16;
    private readonly checkboxPadding: number = 4;

    constructor(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        width: number,
        height: number,
        value: boolean | MultipleValues,
        isActive: boolean,
        levelDesigner: LevelDesignerComponent,
        propertyEditor: PropertyEditor
    ) {
        super(ctx, x, y, width, height, value, isActive, levelDesigner, propertyEditor);
    }

    public draw(): void {
        // Draw checkbox background
        this.ctx.save();
        this.ctx.fillStyle = '#ffffff';
        this.ctx.strokeStyle = this.isActive ? '#007bff' : '#666666';
        this.ctx.lineWidth = 1;
        
        // Draw checkbox box
        this.ctx.beginPath();
        this.ctx.rect(
            this.x + this.checkboxPadding,
            this.y + (this.height - this.checkboxSize) / 2,
            this.checkboxSize,
            this.checkboxSize
        );
        this.ctx.fill();
        this.ctx.stroke();

        // Draw checkmark or indeterminate state
        if (this.value === true) {
            // Draw checkmark
            this.ctx.strokeStyle = '#007bff';
            this.ctx.lineWidth = 2;
            this.ctx.beginPath();
            this.ctx.moveTo(this.x + this.checkboxPadding + 4, this.y + (this.height - this.checkboxSize) / 2 + 8);
            this.ctx.lineTo(this.x + this.checkboxPadding + 7, this.y + (this.height - this.checkboxSize) / 2 + 11);
            this.ctx.lineTo(this.x + this.checkboxPadding + 12, this.y + (this.height - this.checkboxSize) / 2 + 5);
            this.ctx.stroke();
        } else if (this.value instanceof MultipleValues) {
            // Draw indeterminate state (horizontal line)
            this.ctx.strokeStyle = '#007bff';
            this.ctx.lineWidth = 2;
            this.ctx.beginPath();
            this.ctx.moveTo(this.x + this.checkboxPadding + 4, this.y + (this.height - this.checkboxSize) / 2 + 8);
            this.ctx.lineTo(this.x + this.checkboxPadding + 12, this.y + (this.height - this.checkboxSize) / 2 + 8);
            this.ctx.stroke();
        }

        this.ctx.restore();
    }

    public handleClick(x: number, y: number): boolean {
        const checkboxX = this.x + this.checkboxPadding;
        const checkboxY = this.y + (this.height - this.checkboxSize) / 2;

        if (x >= checkboxX && x <= checkboxX + this.checkboxSize &&
            y >= checkboxY && y <= checkboxY + this.checkboxSize) {
            this.value = !this.value;
            this.displayValue = this.value.toString();
            this.propertyEditor.commitValueFromInput(this, this.value);
            return true;
        }

        return false;
    }

    public handleKeyEvent(event: KeyboardEvent): boolean {
        if (!this.isActive) return false;

        if (event.key === ' ' || event.key === 'Enter') {
            this.value = !this.value;
            this.displayValue = this.value.toString();
            this.propertyEditor.commitValueFromInput(this, this.value);
            return true;
        }

        return false;
    }

    public focus(): void {
        this.isActive = true;
    }

    public blur(): void {
        this.isActive = false;
    }

    override getValue(): boolean {
        return this.value === true;
    }

    override setValue(value: any): void {
        if(value instanceof MultipleValues) {
            this.value = value;
            this.displayValue = value.toString();
        }
        else{
            this.value = value === true;
            this.displayValue = this.value.toString();
        }
    }
} 
